import React from "react";

const OrderTracking = ({ statusHistory = [] }) => {
    if (!statusHistory?.length) return null;

    const totalSteps = statusHistory?.length - 1;

    return (
        <div className="w-full bg-white border rounded-xl shadow-sm p-4 sm:p-6 mt-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-6">
                Live Order Tracking Status
            </h3>

            <div className="hidden md:flex items-center justify-between w-full relative">
                <div className="absolute top-4 left-0 w-full h-1 bg-gray-300 rounded"></div>
                <div
                    className="absolute top-4 left-0 h-1 bg-green-600 rounded transition-all duration-300"
                    style={{
                        width: `${(totalSteps / (statusHistory.length - 1)) * 100}%`,
                    }}
                ></div>
                {statusHistory?.map((step, index) => {
                    return (
                        <div
                            key={step._id}
                            className="relative z-10 flex flex-col items-center w-full"
                        >
                            <div className="w-9 h-9 flex items-center justify-center rounded-full text-sm font-bold text-white bg-green-600">
                                {index + 1}
                            </div>

                            <p className="mt-3 text-sm text-center text-green-700 font-semibold min-h-[40px] line-clamp-2   ">
                                {step.status}
                            </p>

                            <p className="text-xs text-gray-400 mt-1 min-h-[18px]">
                                {new Date(step.date).toLocaleString()}
                            </p>
                        </div>
                    );
                })}
            </div>


            <div className="md:hidden flex flex-col relative pl-6 gap-6">

                <div className="absolute left-4 top-0 h-full w-[2px] bg-gray-300"></div>

                {statusHistory?.map((step, index) => {
                    const isLast = index === statusHistory.length - 1;

                    return (
                        <div key={step._id} className="flex items-start gap-4 relative">

                            <div
                                className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-bold z-10
          ${isLast ? "bg-green-600" : "bg-green-600"}`}
                            >
                                {index + 1}
                            </div>

                            <div className="flex-1 pb-6">
                                <p className="text-sm font-semibold text-green-700">
                                    {step.status}
                                </p>

                                <p className="text-xs text-gray-400 mt-1">
                                    {new Date(step.date).toLocaleString()}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OrderTracking;
